import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_USEAGE_HISTORY } from "../../../../Urls.js";


const initialState = {
    usageHistoryData: { data: [], loading: false }
};

export const getUsageHistory = createAsyncThunk(
    "app/get/usageHistory",
    async (payload) => {
        const response = await axios.post(GET_USEAGE_HISTORY, { ...payload });
        return response;
    }
);

export const useageSlice = createSlice({
    name: "useageSlice/payemnet",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsageHistory.pending, (state) => {
                state.usageHistoryData.loading = true;
            })
            .addCase(getUsageHistory.fulfilled, (state, action) => {
                state.usageHistoryData.loading = false;
                state.usageHistoryData.data = action?.payload?.data?.data;
            })
            .addCase(getUsageHistory.rejected, (state) => {
                state.usageHistoryData.loading = false;
            });
    }

});

export default useageSlice.reducer;